import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcraiSlide]'
})
export class SlideDirective {

  constructor(
    public template: TemplateRef<any>
  ) { }

}
